<template>
  <el-container>
      <el-header style="height:50px;padding-top:10px;">
        <el-page-header @back="goBack">
          <template slot="content">
            个人中心
          </template>
      
        </el-page-header>
      </el-header>
      <el-main>
        <el-container>
          <el-aside style="width:200px;border-right: 1px solid #e7e9eb;
                position: relative;
                outline: none;
                color: #767c85;">
            
            <el-row>
              <el-col style="text-align:center">
                <el-avatar :src="this.userinfo.headimgurl" :size="80"></el-avatar>
                <br>
                <span style="color:#000;font-weight:bold">HI，{{this.userinfo.username}}</span>
              </el-col>
             
            </el-row>
            
            <el-divider></el-divider>
            <el-menu style="border-right:0px solid #FFF;" :default-active="$route.path" router>
              <el-menu-item index="/user/profile">
                <i class="fa fa-user fa-fw"></i>&nbsp; 
                <span slot="title">个人资料</span>
              </el-menu-item>
              <el-menu-item index="/user/changepwd">
                <i class="fa fa-key fa-fw"></i>&nbsp;
                <span slot="title">修改密码</span>
              </el-menu-item>
              <!-- <el-menu-item index="/user/bindweixin">
                <i class="fa fa-weixin fa-fw"></i>&nbsp;
                <span slot="title">绑定微信</span>
              </el-menu-item> -->
              <el-menu-item index="/user/workcard">
                <i class="fa fa-drivers-license-o fa-fw"></i>&nbsp;
                <span slot="title">研究二维码</span>
              </el-menu-item>
            </el-menu>
            

          </el-aside>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
</template>

<script>
export default {
    data() {
      return {
        userinfo:{},
      }
    },
    created() {
      
    },
    mounted() {
      this.getProfile();
    },
    methods: {
      goBack() {
        this.$router.push({ name: 'home-subject', params: { }})
      },
      getProfile(){
        this.$http.get('user/profile').then((res) => {
            this.userinfo = res.data.info;
        });
      },
    }
  };
</script>

<style>
/* .el-header {
  height:50px;
  padding-top:10px;
} */
</style>